'use client';

import type { CityCode } from '@loci/city-editions';

import { useCityReturnUrl } from '@/hooks/useCityReturnUrl';
import { crossHostSignup } from '@/lib/cross-host-redirect';
import type { CrossHostStageOptions } from '@/lib/cross-host-urls';

/**
 * Signup href for the marketing-city chrome — the twin of
 * {@link useCitySignInHref}. Returns `providedSignUpUrl` when the caller
 * supplies one; otherwise `crossHostSignup(currentUrl)` so a visitor who signs
 * up from the account chooser or the sitemap lands back on the city page they
 * were reading (FRE-1389), not the app feed.
 *
 * `from=city-nav` is NOT appended here — the chrome applies
 * `cityNavSignUpHref` at render time so an override URL gets it too.
 */
export function useCitySignUpHref(
  cityCode: CityCode,
  providedSignUpUrl: string | undefined,
  stage?: CrossHostStageOptions,
): string {
  const currentUrl = useCityReturnUrl(cityCode, stage);
  return providedSignUpUrl ?? crossHostSignup(currentUrl, stage);
}
